/**
 * Constants for email capture functionality
 */

/**
 * Default source attribution for email captures
 * When no `utm_source` is provided, we intentionally store a blank source (unknown).
 */
export const DEFAULT_EMAIL_SOURCE = "" as const;
